import {combine} from 'effector';
import {createGate} from 'effector-react/effector-react.cjs';

import {
    fetchDeclarationDetails,
    setDeclarationConfirmStatus,
    setDeclarationReviewStatus,
} from 'api';
import {rootDomain} from 'core/rootDomain';

import {DeclarationDetails} from 'types/declarations';

const domain = rootDomain.createDomain('DeclarationDetailDomain');
export const Gate = createGate<{id: string}>('DeclarationDetailsGate');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDeclarationsDetailsFx',
    handler: fetchDeclarationDetails,
});

export const setReviewFx = domain.createEffect({
    name: 'setReviewFx',
    handler: setDeclarationReviewStatus,
});

export const setConfirmFx = domain.createEffect({
    name: 'setConfirmFx',
    handler: setDeclarationConfirmStatus,
});

export const setReviewEvent = domain.createEvent<{id: string; gd_number: string}>();
export const setConfirmEvent = domain.createEvent<{id: string; confirm: boolean}>();

export const data$ = domain.createStore<DeclarationDetails | null>(null);

export const dataState$ = combine({
    data: data$,
    isLoading: fetchDataFx.pending,
});
